export default (props, vars) =>
  !!vars?.['useapplicationoffer2']?.['isError'] ||
  ![
    vars?.['useapplicationoffer2']?.['applicationOffer']?.STAGES.OFFER_SENT,
    vars?.['useapplicationoffer2']?.['applicationOffer']?.STAGES.ACCEPTED,
    vars?.['useapplicationoffer2']?.['applicationOffer']?.STAGES.ENROLLED,
    vars?.['useapplicationoffer2']?.['applicationOffer']?.STAGES
      .STUDENT_DECLINED,
  ].includes(vars?.['useapplicationoffer2']?.['applicationOffer']?.stage_id);
